/**
 * Witboost does not resolve the `parameters` configured on a `builder.systemPage`:
 * the page definition asks for the entity with `valuePath: entity`, the served
 * configuration carries that verbatim, and the mount function still receives an
 * empty object. Until that is fixed, read the entity ourselves.
 *
 * Nothing here talks to our own origin. The microfrontend runs inside the
 * Witboost document, so a relative URL resolves against the host and the request
 * is same-origin — no CORS, and the token we were handed is the right credential.
 */

export type EntityRef = { kind: string; namespace: string; name: string };

// e.g. /my-projects/catalog/default/system/domain.name.0/ontology-editor
const CATALOG_PATH = /\/catalog\/([^/]+)\/([^/]+)\/([^/]+)/;

export function entityRefFromPath(pathname: string): EntityRef | undefined {
  const match = CATALOG_PATH.exec(pathname);

  if (!match) {
    return undefined;
  }

  const [, namespace, kind, name] = match;
  return { kind, namespace, name };
}

export async function fetchHostEntity(token: string): Promise<unknown> {
  const ref = entityRefFromPath(window.location.pathname);

  if (!ref) {
    return undefined;
  }

  const url = `/api/catalog/entities/by-name/${encodeURIComponent(ref.kind)}/${encodeURIComponent(
    ref.namespace,
  )}/${encodeURIComponent(ref.name)}`;

  try {
    const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });

    if (!response.ok) {
      console.warn('[Catalog] Could not read the entity from the host:', response.status);
      return undefined;
    }

    return await response.json();
  } catch (error) {
    console.warn('[Catalog] Could not reach the host catalog', error);
    return undefined;
  }
}
